var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'mb-2',
    'px-3',
    'py-3',
    'job-question',
    'position-relative' ]},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('span',{staticClass:"job-question-label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])]),_c('b-col',{attrs:{"cols":"6"}},[(_vm.responseValues.length)?_vm._l((_vm.responseValues),function(value,i){return _c('div',{key:'mdjp_rv_' + _vm.jobQuestion.id + '_' + i,staticClass:"text-break",domProps:{"innerHTML":_vm._s(value)}})}):_c('div',{domProps:{"innerHTML":_vm._s('N/A')}})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }